import { type IconProps } from '@ubnt/icons';
import ClosePrimaryIcon from '@ubnt/icons/ClosePrimaryIcon';
import Button from '@ubnt/ui-components/Button/Button';
import { clsx } from 'clsx';

import classes from './DefaultSidePanelHeader.module.scss';

export interface HeaderProps {
  className?: string;
  onClose?: React.MouseEventHandler;
  children?: React.ReactNode;
  closeIconSize?: 'small' | 'medium';
  closeIconProps?: Omit<IconProps, 'size'>;
}

const DefaultHeader = (props: HeaderProps) => {
  const { className, onClose, children, closeIconSize = 'medium', closeIconProps: restProps } = props;
  if (!children && !onClose) return <></>;
  return (
    <header className={clsx(className, classes.header)}>
      <div className={classes.title}>{children}</div>
      {onClose && (
        <Button
          type="button"
          variant="tertiary"
          data-testid="close-button"
          className={classes.headerButton}
          Icon={ClosePrimaryIcon}
          iconSize={closeIconSize}
          onClick={onClose}
          iconProps={restProps}
        />
      )}
    </header>
  );
};

export default DefaultHeader;
